export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "clear-search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear search"])},
        "toggle-options": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show or hide options"])}
      },
      "fr": {
        "clear-search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer la recherche"])},
        "toggle-options": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afficher ou masquer les choix"])}
      }
    }
  })
}
